<template>
    <layout v-bind:user="loginUser" v-bind:company="company" v-bind:brands="brands" v-bind:shops="shops">
        <main class="ly_main"><div class="wrap"><div class="inner">

            <section>
                <!-- ここから -->

                <!--:::::::::::::::::::::::::::::::::::::::::::::::
                    Heading
                :::::::::::::::::::::::::::::::::::::::::::::::::-->
                <h1 class="heading_page-title flex _y-center">
                    <div class="main"><span>会社設定</span></div>
                    <div class="controller flex _right _y-center">
                        <div>
                            <button class="btn_link _cancel md_icon-text" v-on:click="clickRecessCompany()">
                                <div class="inner">
                                    <span v-if="company.status == 0"><div class="icon"><SvgIconDelete /></div>休会中</span>
                                    <span v-if="company.status == 1"><div class="icon"><SvgIconDelete /></div>休会</span>
                                </div>
                            </button>
                        </div><!--/.add-->
                        <div>
                            <button class="btn_link _cancel md_icon-text" v-on:click="clickDeleteCompany()">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconDelete /></div>退会</span>
                                </div>
                            </button>
                        </div><!--/.add-->
                        <div>
                            <Link class="btn_link md_icon-text _white" :href="route(inviteRoute)">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconSend /></div>メンバー招待</span>
                                </div>
                            </Link>
                        </div><!--/.add-->
                    </div><!--/.controller-->
                </h1><!--/.heading_page-title-->

                <!--:::::::::::::::::::::::::::::::::::::::::::::::
                    TeamList
                :::::::::::::::::::::::::::::::::::::::::::::::::-->
                <div class="team_component">

                    <!-- TeamList -->
                    <ul class="team_list">

                        <!-- Item -->
                        <li v-for="employee in allEmployees" v-bind:key="employee.id">
                            <div class="inner">

                                <!-- Avatar -->
                                <div class="avatar">
                                    <img v-if="employee.icon" v-bind:src="this.$store.state.const.AWS_S3_URL_HOST + employee.icon" alt="">
                                    <img v-if="!employee.icon" v-bind:src="'/img/no-image.svg'">
                                </div><!-- /.avatar -->

                                <!-- Detail -->
                                <div class="detail">
                                    <div class="role" v-bind:class="{_admin: employee.role == 0}"><span>{{ pulldownLists[employee.role].name }}</span></div>
                                    <div class="name"><span>{{ employee.name }}</span></div>
                                    <div class="email"><span>{{ employee.email }}</span></div>
                                </div><!-- /Detail -->

                                <!-- Edit -->
                                <div class="edit">
                                    <button class="btn_svg-icon" data-modal="ModalOpenAdminSetting" v-on:click="openModal(employee.id, 'role')">
                                        <SvgIconEdit />
                                    </button>
                                </div><!-- /Edit -->

                                <!-- Delete -->
                                <div class="edit" v-if="employee.role != 0">
                                    <button class="btn_svg-icon" data-modal="ModalOpenAdminSetting" v-on:click="openModal(employee.id, 'delete')">
                                        <SvgIconDelete />
                                    </button>
                                </div><!-- /Delete -->

                            </div>
                        </li><!-- Item -->

                    </ul><!-- /ul.team-list -->

                </div><!-- /.team_component -->

                <!--:::::::::::::::::::::::::::::::::::::::::::::::
                    Modal1
                :::::::::::::::::::::::::::::::::::::::::::::::::-->
                <div class="modal_container ModalOpenAdminSetting" v-bind:class="{_open:isOpen}">
                    <div class="modal_wrap" v-if="targetUser.id == loginUser.id && loginUser.role == 0 && purpose == 'role'">

                        <!-- Title -->
                        <div class="modal_title">
                            <h3><span>どのユーザーに管理者権限を譲渡しますか？</span></h3>
                        </div>

                        <!-- Body -->
                        <div class="modal_body">
                            <div class="inner">
                                <p><span class="md_text-bold _link-color">{{ targetUser.name }}</span> 様から</p>
                                <p>
                                    <!-- SelectItem -->
                                    <div class="item form_select" style="margin: 1rem 0;">
                                        <div class="input-row">
                                            <select name="" select v-bind:id="'manager-' + targetUser.id" v-on:change="selectManger">
                                                <option value="" hidden v-if="exceptManger.length > 0">選択してください</option>
                                                <option value="" hidden v-else>譲渡できるメンバーがいません</option>
                                                <option v-for="list in exceptManger" v-bind:selected="list.role == targetUser.role" v-bind:key="targetUser.id" v-bind:value="list.id">{{ list.name }} 様</option>
                                            </select>
                                        </div>
                                    </div>
                                </p>
                                <p>へ変更</p><br>
                                <p>※ 譲渡後は一般ユーザーになるため、一般ユーザーが閲覧可能なページへ移動します</p>
                            </div>
                        </div>

                        <!--btn-link-wrap-->
                        <div class="btn_link-wrap">

                            <button class="btn_link _cancel md_icon-text js-modal-close" v-on:click="closeModal">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                                </div>
                            </button>

                            <button class="btn_link md_icon-text _white" v-on:click="changeRole(targetUser.id)">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconCheck /></div>決定</span>
                                </div>
                            </button>

                        </div><!--/.btn-link-wrap-->

                    </div>

                    <div class="modal_wrap" v-if="targetUser.id != loginUser.id && loginUser.role == 0 && purpose == 'role'">

                        <!-- Title -->
                        <div class="modal_title">
                            <h3><span>対象ユーザーの権限を何に変更しますか？</span></h3>
                        </div>

                        <!-- Body -->
                        <div class="modal_body">
                            <div class="inner">
                                <p><span class="md_text-bold _link-color">{{ targetUser.name }}</span> 様の権限を {{ pulldownLists[targetUser.role].name }}から</p>
                                <p>
                                    <!-- SelectItem -->
                                    <div class="item form_select" style="margin: 1rem 0;">
                                        <div class="input-row">
                                            <select name="" v-bind:id="'role-' + targetUser.id" v-on:change="selectRole">
                                                <option value="" hidden>{{ pulldownLists[targetUser.role].name }}</option>
                                                <option v-for="list in pulldownLists" v-bind:selected="list.role == targetUser.role" v-bind:key="targetUser.id" v-bind:value="list.role">{{ list.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </p>
                                <p>へ変更</p>
                            </div>
                        </div>

                        <!--btn-link-wrap-->
                        <div class="btn_link-wrap">

                            <button class="btn_link _cancel md_icon-text js-modal-close" v-on:click="closeModal">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                                </div>
                            </button>

                            <button class="btn_link md_icon-text _white" v-on:click="changeRole(targetUser.id)">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconCheck /></div>決定</span>
                                </div>
                            </button>

                        </div><!--/.btn-link-wrap-->

                    </div>

                    <div class="modal_wrap" v-if="purpose == 'delete'">

                        <!-- Title -->
                        <div class="modal_title">
                            <h3><span>対象ユーザーを削除しますか？</span></h3>
                        </div>

                        <!-- Body -->
                        <div class="modal_body">
                            <div class="inner">
                                <p><span class="md_text-bold _link-color">{{ targetUser.name }}</span> 様 を削除する</p>
                            </div>
                        </div>

                        <!--btn-link-wrap-->
                        <div class="btn_link-wrap">

                            <button class="btn_link _cancel md_icon-text js-modal-close" v-on:click="closeModal">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                                </div>
                            </button>

                            <button class="btn_link md_icon-text _white"  v-on:click="deleteMember(targetUser.id)">
                                <div class="inner">
                                    <span><div class="icon"><SvgIconCheck /></div>決定</span>
                                </div>
                            </button>

                        </div><!--/.btn-link-wrap-->

                    </div>
                    <div class="modal_close-ovl js-modal-close"></div>
                </div>

                <!--:::::::::::::::::::::::::::::::::::::::::::::::
                    ModalBackGround
                :::::::::::::::::::::::::::::::::::::::::::::::::-->
                <div class="modal_bg" v-bind:class="{_on:isOpen}"></div>

                <!-- ここまで -->
            </section>
            <section>
                <TeamCompany :company="company" :pageType="pageType" @openAlertModal="openAlertModal"/>
            </section>
            <AlertModal 
                v-if="showAlertModal" 
                @close="closeAlertModal" 
                :title="alert_modal_title" 
                :message="alert_modal_message"
                :mode="alert_modal_mode" 
            />
            <ConfirmModalWithPromise ref="confirmModal" />
        </div></div><div class="heading_page-title-en"><span>{{backName}}</span></div></main>
    </layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import { Link } from '@inertiajs/inertia-vue3'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'
    import ConfirmModalWithPromise from '@/components/Admin/ComponentList/ConfirmModalWithPromise'
    import TeamCompany from '@/components/Admin/TeamCompany'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconSend from '@/components/EndUser/svg/SvgIconSend'

    export default {
        components: {
            "Link": Link,
            "AlertModal": AlertModal,
            "ConfirmModalWithPromise": ConfirmModalWithPromise,
            "SvgIconEdit": SvgIconEdit,
            "SvgIconDelete": SvgIconDelete,
            "SvgIconCancel": SvgIconCancel,
            "SvgIconCheck": SvgIconCheck,
            "SvgIconSend": SvgIconSend,
            "layout": AdminLayout,
            "TeamCompany": TeamCompany,
        },
        data() {
            return {
                isOpen: false,
                pulldownLists: [
                    {role: 0, name: '管理者'},
                    {role: 1, name: '一般'}
                ],
                targetUser: '',
                selectedRole: '',
                selectedManager: '',
                purpose: '',
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: ''
            }
        },
        props: {
            loginUser: Object,
            employees: Object,
            company: Object,
            brands: Object,
            shops: Object,
        },
        mounted(){
            if(this.$page.props.flash.success?.length > 0){
                const successMessage = this.$page.props.flash.success.split(",");
                this.openAlertModal("success", successMessage[0], successMessage[1]); //確認済み
            }
        },
        watch: {
            '$page.props': {
                handler(value){
                    if(value.flash.success){
                        const successMessage = value.flash.success.split(",");
                        this.openAlertModal("success", successMessage[0], successMessage[1]); //確認済み
                    }
                },
                deep: true
            }
        },
        methods: {
            changeRole(userId) {
                this.isOpen = false;
                var user = this.employees.find((employee) => employee.id == userId);
                if (this.selectedManager) {
                    var newManager = this.employees.find((employee) => employee.id == this.selectedManager);
                    if (this.selectedManager == user.id) {
                        this.selectedManager = '';
                    return;
                    }
                }
                if (this.selectedRole != '' && this.selectedRole == user.role) {
                    this.selectedRole = '';
                    return;
                }
                if (this.selectedManager == '' && this.selectedRole == '') {
                    return;
                }
                var routeName = '';
                if (user.type == 1) {
                    routeName = 'admin.shop.team.role_change';
                } else if (user.type == 2) {
                    routeName = 'admin.brand.team.role_change';
                } else if (user.type == 3) {
                    routeName = 'admin.showroom.team.role_change';
                }
                const data = reactive({
                    company_id: this.loginUser.company_id,
                    user_id: user.id,
                    selected_manager: this.selectedManager,
                    selected_role: this.selectedRole,
                })
                Inertia.post(route(routeName), data, {
                    preserveScroll: true,
                    onError: (errors) => {
                        if (errors.selected_role) {
                            this.openAlertModal("error", "エラー", errors.selected_role); //確認済み
                            location.reload();
                        }
                    },
                    onFinish: visit => {
                        this.selectedRole = '';
                        this.selectedManager = '';
                    },
                    onSuccess: visit => {
                        this.openAlertModal("success", "変更完了", "ユーザー権限の変更が完了しました"); //確認済み
                    },
                })
            },
            deleteMember(userId) {
                this.isOpen = false;
                var user = this.employees.find((employee) => employee.id == userId);
                var routeName = '';
                if (user.type == 1) {
                    routeName = 'admin.shop.team.delete_member';
                } else if (user.type == 2) {
                    routeName = 'admin.brand.team.delete_member';
                } else if (user.type == 3) {
                    routeName = 'admin.showroom.team.delete_member';
                }
                const data = reactive({
                    company_id: this.loginUser.company_id,
                    target_user_id: user.id,
                })
                Inertia.post(route(routeName), data, {
                    preserveScroll: true,
                    onError: (errors) => {
                        if (errors.target_user_id) {
                            this.openAlertModal("error", "エラー", errors.target_user_id); //確認済み
                            location.reload();
                        }
                    },
                    onSuccess: visit => {
                        const message = this.targetUser.name + '様をメンバーから削除しました'; 
                        this.openAlertModal("success", "ユーザー削除", message); //確認済み
                    },
                    onFinish: visit => {
                    },
                })
            },
            selectRole(event) {
                this.selectedRole = event.target.value;
            },
            selectManger(event) {
                this.selectedManager = event.target.value;
            },
            openModal(userId, purpose) {
                if (this.isOpen == true) {
                    this.selectedRole = '';
                    this.selectedManager = '';
                    this.targetUser = '';
                    this.purpose = '';
                    this.isOpen = false;
                } else {
                    this.targetUser = this.employees.find((user) => user.id == userId);
                    this.purpose = purpose;
                    this.isOpen = true;
                }
            },
            closeModal() {
                this.selectedRole = '';
                this.selectedManager = '';
                this.targetUser = '';
                this.purpose = '';
                this.isOpen = false;
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';
            },
            async clickDeleteCompany() {
                // 退会
                let plan_check = true;

                for(let i in this.brands) {
                    let brand = this.brands[i];
                    // basicプラン
                    if (brand.plan == 1 && brand.subscription_status == 'active') {
                        plan_check = false;
                    }
                }
                if (!plan_check) {
                    this.openAlertModal("error", "プランのキャンセルが必要です", 'お支払い中のbasicプランがあります。退会するにはプランのキャンセルが必要です。'); //確認済み
                    return;
                }
                const confirm = await this.$refs.confirmModal.show({ // 確認済み
                    title: '退会してもよろしいですか？',
                    message: '本当に退会してもよろしいですか？',
                    mode: "confirm",
                    name: "teamConfirm"
                })
                if (confirm) {
                    if (this.pageType == 1) {
                        var routeName = 'admin.shop.delete.company';
                    } else if (this.pageType == 2) {
                        var routeName = 'admin.brand.delete.company';
                    } else if (this.pageType == 3) {
                        var routeName = 'admin.showroom.delete.company';
                    }

                    axios.post(route(routeName))
                    .then(response => {
                        location.reload();
                    })
                }
            },
            async clickRecessCompany() {
                // 休会
                if (this.pageType == 1) {
                    var routeName = 'admin.shop.recess.company';
                } else if (this.pageType == 2) {
                    var routeName = 'admin.brand.recess.company';
                } else if (this.pageType == 3) {
                    var routeName = 'admin.showroom.recess.company';
                }
                if (this.company.status == 1) {
                    // 休会
                    let plan_check = true;
                    for(let i in this.brands) {
                        let brand = this.brands[i];
                        // basicプラン
                        if (brand.plan == 1 && brand.subscription_status == 'active') {
                            plan_check = false;
                        }
                    }
                    if (!plan_check) {
                        this.openAlertModal("error", "プランのキャンセルが必要です", 'お支払い中のbasicプランがあります。休会するにはプランのキャンセルが必要です。'); //確認済み
                        return;
                    }
                    const confirm = await this.$refs.confirmModal.show({ // 確認済み
                        title: '休会してもよろしいですか？',
                        message: '本当に休会してもよろしいですか？',
                        mode: "confirm",
                        name: "teamConfirm"
                    })
                    if (confirm) {
                        axios.post(route(routeName))
                        .then(response => {
                            location.reload();
                        })
                    }
                } else {
                    const confirm = await this.$refs.confirmModal.show({ // 確認済み
                        title: '再開してもよろしいですか？',
                        message: '再開してもよろしいですか？？',
                        mode: "confirm",
                        name: "teamConfirm"
                    })
                    // 再開
                    if (confirm) {
                        axios.post(route(routeName))
                        .then(response => {
                            location.reload();
                        })
                    }
                }
            },
        },
        computed: {
            pageType() {
                if (location.pathname == '/admin/shop/manager/team') {
                    return 1;
                } else if (location.pathname == '/admin/brand/manager/team') {
                    return 2;
                }  else if (location.pathname == '/admin/showroom/manager/team') {
                    return 3;
                }
            },
            allEmployees() {
                if(this.employees) {
                    return this.employees;
                } else return null;
            },
            exceptManger() {
                var employeeList = [];
                if(this.employees) {
                    this.employees.forEach(employee => {
                        if (employee.role == 1) {
                            employeeList.push(employee);
                        }
                    });
                    if (employeeList) {
                        return employeeList;
                    } else return null;
                } else return null;
            },
            inviteRoute() {
                if(this.loginUser) {
                    switch (this.loginUser.type) {
                        case 1:
                            return 'admin.shop.invite.member';
                            break;
                        case 2:
                            return 'admin.brand.invite.member';
                            break;
                        case 3:
                            return 'admin.showroom.invite.member';
                            break;
                        default:
                            return '';
                            break;
                    }
                } else return null;
            },
            backName() {
                if (this.loginUser.type == 0) {
                    return 'Admin';
                } else if (this.loginUser.type == 1) {
                    return 'Shop';
                } else if (this.loginUser.type == 2) {
                    return 'Brand';
                } else if (this.loginUser.type == 3) {
                    return 'ShowRoom';
                }
            },
        },
    }
</script>
